/**
 * Whether a grid event started on a link inside the row. AG Grid listens for
 * row clicks natively, so a React `stopPropagation` on the link runs too late
 * to stop the row's own handler — the row handler checks the target instead.
 */
export const isLinkEvent = (event: Event | null | undefined): boolean =>
  event?.target instanceof Element && event.target.closest('a') !== null
